import StandKitsSync from "../../../utils/localDB/standkits";
import StandKitsApi from "../standkits";

class StandKitsManager {

    async getList(params) {
        if (params.isOffline) {
            return await new StandKitsSync().getList(params)
        }
        try {
            const result = await StandKitsApi.getList(params)
            window.postMessage('online')
            return result
        } catch (error) {
            const result = await new StandKitsSync().getList(params)
            window.postMessage('offline')
            return result
        }
    }
}

export default new StandKitsManager()
